import React, { useEffect, useState } from "react";
import get from "lodash/get";

import { AdContainer } from "../../ads";
import { filterStory, getCollection, removeSponsoredStories } from "../../helper/api";

import StoryCard15 from "../../molecules/story-card15";
import StoryCard16 from "../../molecules/story-card16";
import StoryCard17 from "../../molecules/story-card17";
import StoryCard20 from "../../molecules/story-card20";
import StoryCard21 from "../../molecules/story-card21";
import TopNewsMobile from "../../molecules/topnews-mobile";
import CollectionTitleHeader from "../../molecules/collection-title-header";

import Separator from "../../atoms/separator";

import "./top-news-1.m.css";

function TopNews1({ collection, index }) {
  if (!(collection && collection.items)) return null;

  const [isMobile, setMobile] = useState(false);

  // Get stories from the collection
  let stories = filterStory(collection);

  const mobileStories = [...stories];
  const [brandspotStories, setBrandspotStories] = useState([]);
  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);
  const iframeWidget = get(collection, ["associated-metadata", "widget"], null);
  const useBrandspotStories = get(collection, ["metadata", "brand-spot"], false);
  const storiesCount = brandspotStories.length == 0 ? 6 : 9;

  if (!stories.length) return null;

  useEffect(() => {
    if (["true", "True", "t", "T"].includes(useBrandspotStories)) {
      getCollection("brandspot-home").then((resp) => setBrandspotStories(resp));
    } else {
      setBrandspotStories([]);
    }
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  stories = !isMobile && brandspotStories.length == 0 ? removeSponsoredStories(stories) : stories;
  brandspotStories[0] && stories.splice(9, 0, brandspotStories[0]);
  brandspotStories[1] && stories.splice(10, 0, brandspotStories[1]);

  // const isBrandSpot = !["true", "True", "t", "T"].includes(useBrandspotStories);

  return (
    <>
      <div className="hide-mobile">
        <CollectionTitleHeader collection={collection} index={index} />
        <div styleName="wrapper">
          <div styleName="col1">
            {stories?.slice(storiesCount + 2, storiesCount + 7).map((item, index) => (
              <div styleName="col1-card" key={index}>
                <StoryCard20 story={item} key={index} />
              </div>
            ))}
            {stories?.slice(storiesCount + 7, storiesCount + 10).map((item, index) => (
              <div styleName="col1-card last-three-cards" key={index}>
                <StoryCard20 story={item} key={index} clamp={2} />
              </div>
            ))}
          </div>

          <div styleName="col2">
            <div styleName="col2-big-card">
              <StoryCard21 story={stories[0]} />
            </div>
            <div styleName="col2-small-cards">
              {stories?.slice(1, 4).map((item, index) => (
                <div key={index}>
                  <StoryCard15 story={item} showSectionName={true} />
                </div>
              ))}
            </div>
          </div>
          <div styleName="col3">
            <div styleName="col3-first-cards">
              <div styleName="col3-section-1">
                {stories?.slice(4, storiesCount).map((item, index) => (
                  <div styleName="col3-first-card" key={index}>
                    <StoryCard16 story={item} type="b" />
                  </div>
                ))}
              </div>
              <div styleName="col3-section-2">
                {stories?.slice(storiesCount, storiesCount + 2).map((item, index) => (
                  <div styleName="col3-first-card" key={index}>
                    <StoryCard17 story={item} type="b" />
                  </div>
                ))}
              </div>
              <div styleName="col3-section-3">
                {desktopAdUnitId && brandspotStories.length == 0 ? (
                  <div styleName="ad-wrapper">
                    <AdContainer
                      AdClassName="standard-300x250"
                      id="div-gpt-ad-1680156228599-0"
                      desktop={desktopAdUnitId}
                    />
                  </div>
                ) : null}
                {iframeWidget ? <div dangerouslySetInnerHTML={{ __html: iframeWidget }}></div> : null}
              </div>
            </div>
          </div>
        </div>
        <div styleName="separator-wrapper">
          <div>
            <Separator />
          </div>
          <div>
            <Separator />
          </div>
          <div>
            <Separator />
          </div>
        </div>
      </div>

      <div className="hide-desktop">
        <TopNewsMobile
          stories={mobileStories}
          collectionName={collection.metadata?.["display-name"] || collection?.name}
          collection={collection}
          disableAds={index !== 1}
          brandspotStories={brandspotStories}
        />
      </div>
    </>
  );
}

export default TopNews1;
